module.exports = __webpack_public_path__ + "static/media/ET071C new.a341da9f.jpg";